import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExclamationFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 8C13.383 8 8 13.383 8 20C8 26.617 13.383 32 20 32C26.617 32 32 26.617 32 20C32 13.383 26.617 8 20 8ZM21.645 13L21 22H19L18.392 13H21.645ZM20 28C18.895 28 18 27.105 18 26C18 24.895 18.895 24 20 24C21.105 24 22 24.895 22 26C22 27.105 21.105 28 20 28Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgExclamationFilled);
export default ForwardRef;
